import styled from "styled-components";

export const AdBannerImg = styled.img`
    display: block;
    max-width: 100%;
    margin-top: 20px;
`;

export const AdBannerContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 35px;
`;

export const AdBanner = styled.div`
    position: relative;
`;

export const AdNotice = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    z-index: 7;
    background-color: #ffffffbf;
    font-size: 13px;
    padding: 0px 3px;
`;
